<rid-dialog
  class="h-dvh"
  [pages]="[
    [
      {
        speaker: 'LEFT',
        content: 'Hallo! Ik ben een ouder.',
      },
      { speaker: 'RIGHT', content: 'En ik ben een kind.' },
      {
        speaker: 'LEFT',
        content: 'Complexe woorden en lange zinnen zijn voor mij geen probleem.',
      },
      {
        speaker: 'RIGHT',
        content: 'Voor mij moet het simpel.',
      },
    ],
    [
      {
        speaker: 'LEFT',
        content: 'Einde.',
      },
      {
        speaker: 'RIGHT',
        content: 'Leuk hoor.',
      },
    ],
  ]"
  (finished)="$router.navigate(['/mechanics/expression'])"
/>
